import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { TabPanel, TabPanelLocation } from '@tabeeb/enums'
import { splatActions } from '@tabeeb/modules/splatModel'
import { getIsGalleryExpansionEnabled } from '@tabeeb/modules/appConfigState/selectors'

import { getIsTabExpanded } from '@tabeeb/modules/sessionTabs/selectors'
import * as rawActions from '../actions'
import * as customVideoActions from '../../customVideo/actions'
import * as spatialModelActions from '../../spatialModel/actions'
import * as threedeeModelActions from '../../3dmodel/actions'
import * as bentleyModelActions from '../../bentleyModel/actions'
import * as bentleyAnalyticsReportActions from '../../bentleyAnalyticsReport/actions'
import * as sessionSharingActions from '../../shareSessionPagesList/actions'
import * as notificationActions from '../../notification/actions'
import * as sessionReviewingActions from '../../reviewSessionPagesList/actions'
import * as classificationAnnotationsActions from '../../classificationAnnotationsPagesTimeline/actions'

import { getGalleryItem } from '../selectors'
import { getIsCurrentUserViewer } from '../../../users/selectors'

import GalleryItem from '../components/GalleryItem'
import * as accountSelectors from '../../account/selectors'
import { contentStateSelectors } from '../../shared/content'
import * as presentationSelectors from '../../presentation/selectors'

class GalleryItemContainer extends Component {
  constructor(props) {
    super(props)

    this.itemActions = {
      loaded: this._handleThumbnailLoaded,
      select: this._handleSelectGalleryItem,
      delete: this._handleDeleteGalleryItem,
      rename: this._handleRenameGalleryItem,
      validate: this._handleRenameValidation,
    }

    this.dragAndDropActions = {
      onDragStart: this._handleDragStart,
      onDragEnd: this._handleDragEnd,
    }

    this.customVideoActions = {
      addItem: this._handleAddItemToCustomVideo,
    }

    this.spatialModelActions = {
      addItem: this._handleAddItemToSpatialModel,
    }

    this.threedeeModelActions = {
      addItem: this._handleAddItemTo3dModel,
    }

    this.bentleyModelActions = {
      addItem: this._handleAddItemToBentleyModel,
    }

    this.bentleyAnalyticsReportActions = {
      addItem: this._handleAddItemToBentleyAnalyticsReport,
    }

    this.sessionSharingActions = {
      addItem: this._handleAddItemToSessionSharing,
    }

    this.sessionReviewingActions = {
      addItem: this._handleAddItemToSessionReviewing,
    }

    this.classificationAnnotationsActions = {
      addItem: this._handleAddItemToClassificationAnnotationsPages,
    }

    this.selectionActions = {
      addItem: this._handleAddItemToSelection,
      removeItem: this._handleRemoveItemFromSelection,
    }

    this.splatModelActions = {
      addItem: this._handleAddItemToSplatModel,
    }
  }

  _handleThumbnailLoaded = () => {
    const {
      item,
      actions: { setGalleryItemThumbnailIsLoaded },
    } = this.props

    setGalleryItemThumbnailIsLoaded({ pageId: item.id })
  }

  _handleSelectGalleryItem = () => {
    const {
      item,
      actions: { onSelectGalleryItem },
    } = this.props

    onSelectGalleryItem({ pageId: item.id })
  }

  _handleDeleteGalleryItem = (e) => {
    e.preventDefault()
    e.stopPropagation()

    const {
      item,
      actions: { setDeleteGalleryItem },
    } = this.props

    setDeleteGalleryItem(item.id)
  }

  _handleRenameGalleryItem = (e) => {
    const {
      item,
      actions: { renameGalleryItemRequest },
    } = this.props

    const newName = e.target.value.trim()
    if (newName.length && newName !== item.thumbnailCaption) {
      renameGalleryItemRequest({ pageId: item.id, folderId: item.folderId, name: newName })
    }
  }

  _handleRenameValidation = (newValue, oldValue) => {
    if (newValue === oldValue) return false
    const valueLength = newValue.trim().length
    if (valueLength === 0 || valueLength > 256) {
      this.props.notificationActions.onAddErrorNotification({
        message: 'Page name cannot be empty or exceed 256 characters.',
      })
      return false
    }
    return true
  }

  _handleAddItemToSelection = () => {
    const {
      item,
      actions: { onAddPageToSelection },
    } = this.props

    onAddPageToSelection(item.id)
  }

  _handleRemoveItemFromSelection = () => {
    const {
      item,
      actions: { onRemovePageFromSelection },
    } = this.props

    onRemovePageFromSelection(item.id)
  }

  _handleDragStart = (e) => {
    if (!e.target.draggable) {
      e.preventDefault()
      e.stopPropagation()

      return
    }

    const {
      item,
      actions: { onStartDraggingPages },
    } = this.props

    onStartDraggingPages({ pageId: item.id, e })
  }

  _handleDragEnd = () => {
    const {
      actions: { clearSelection },
    } = this.props

    clearSelection()
  }

  _handleAddItemToSpatialModel = (e) => {
    e.preventDefault()
    e.stopPropagation()

    const {
      item,
      spatialModelActions: { addImageToModel },
    } = this.props

    addImageToModel(item)
  }

  _handleAddItemToCustomVideo = (e) => {
    e.preventDefault()
    e.stopPropagation()

    const {
      item,
      customVideoActions: { addTimelineItem },
    } = this.props

    addTimelineItem(item)
  }

  _handleAddItemTo3dModel = (e) => {
    e.preventDefault()
    e.stopPropagation()

    const {
      item,
      threedeeModelActions: { addImageTo3dModel },
    } = this.props

    addImageTo3dModel(item)
  }

  _handleAddItemToBentleyModel = (e) => {
    e.preventDefault()
    e.stopPropagation()

    const {
      item,
      bentleyModelActions: { addImageToBentleyModel },
    } = this.props

    addImageToBentleyModel(item)
  }

  _handleAddItemToBentleyAnalyticsReport = (e) => {
    e.preventDefault()
    e.stopPropagation()

    const {
      item,
      bentleyAnalyticsReportActions: { addModelToBentleyAnalyticsReport },
    } = this.props

    addModelToBentleyAnalyticsReport(item)
  }

  _handleAddItemToSessionSharing = (e) => {
    e.preventDefault()
    e.stopPropagation()

    const {
      item,
      sessionSharingActions: { addPageForSharing },
    } = this.props

    addPageForSharing(item)
  }

  _handleAddItemToSessionReviewing = (e) => {
    e.preventDefault()
    e.stopPropagation()

    const {
      item,
      sessionReviewingActions: { addPageForReviewing },
    } = this.props

    addPageForReviewing(item)
  }

  _handleAddItemToClassificationAnnotationsPages = (e) => {
    e.preventDefault()
    e.stopPropagation()

    const {
      item,
      classificationAnnotationsActions: { addPageToClassificationAnnotationsPages },
    } = this.props

    addPageToClassificationAnnotationsPages(item)
  }

  _handleAddItemToSplatModel = (e) => {
    e.preventDefault()
    e.stopPropagation()

    const {
      item,
      splatModelActions: { addImageToSplatModel },
    } = this.props

    addImageToSplatModel(item)
  }

  render() {
    const {
      selectedGalleryItemId,
      is3dModelOpen,
      isBentleyModelOpen,
      isBentleyAnalyticsReportOpen,
      isCustomVideoOpen,
      isSpatialModelOpen,
      isSessionSharingPagesListOpen,
      isSessionReviewingPagesListOpen,
      isClassificationAnnotationsOpen,
      presenterId,
      currentUserId,
      isCallStarted,
      index,
      listRef,
      setSelectedItemRef,
      item,
      isGalleryExpanded,
      isGalleryExpansionEnabled,
      isViewer,
      canAddPointCloudPageToBentleyAnalyticsReport,
      isSplatModelOpen,
    } = this.props

    const props = {
      itemActions: this.itemActions,
      selectionActions: this.selectionActions,
      dragAndDropActions: this.dragAndDropActions,
      customVideoActions: this.customVideoActions,
      spatialModelActions: this.spatialModelActions,
      threedeeModelActions: this.threedeeModelActions,
      bentleyModelActions: this.bentleyModelActions,
      bentleyAnalyticsReportActions: this.bentleyAnalyticsReportActions,
      sessionSharingActions: this.sessionSharingActions,
      sessionReviewingActions: this.sessionReviewingActions,
      classificationAnnotationsActions: this.classificationAnnotationsActions,
      splatModelActions: this.splatModelActions,

      isCustomVideoOpen,
      isSpatialModelOpen,
      is3dModelOpen,
      isBentleyModelOpen,
      isBentleyAnalyticsReportOpen,
      isSessionSharingPagesListOpen,
      isSessionReviewingPagesListOpen,
      isClassificationAnnotationsOpen,
      isSplatModelOpen,

      isSelectedInGallery: selectedGalleryItemId == item.id,
      isAvailable: !isCallStarted || currentUserId === presenterId,

      index,
      listRef,
      setSelectedItemRef,

      isExpanded: isGalleryExpanded && isGalleryExpansionEnabled,

      isViewer,
      canAddPointCloudPageToBentleyAnalyticsReport,

      ...item,
    }

    return <GalleryItem {...props} />
  }
}

GalleryItemContainer.propTypes = {
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,

  selectedGalleryItemId: PropTypes.number,
  isCustomVideoOpen: PropTypes.bool,
  isSpatialModelOpen: PropTypes.bool,
  is3dModelOpen: PropTypes.bool,
  isBentleyModelOpen: PropTypes.bool,
  isBentleyAnalyticsReportOpen: PropTypes.bool,
  isSessionSharingPagesListOpen: PropTypes.bool,
  isSessionReviewingPagesListOpen: PropTypes.bool,
  isClassificationAnnotationsOpen: PropTypes.bool,
  isSplatModelOpen: PropTypes.bool,
  canAddPointCloudPageToBentleyAnalyticsReport: PropTypes.bool,

  ownerId: PropTypes.number.isRequired,
  presenterId: PropTypes.number.isRequired,
  currentUserId: PropTypes.number.isRequired,
  isCallStarted: PropTypes.bool.isRequired,

  listRef: PropTypes.object.isRequired,
  setSelectedItemRef: PropTypes.func.isRequired,

  isGalleryExpanded: PropTypes.bool.isRequired,
  isGalleryExpansionEnabled: PropTypes.bool.isRequired,

  isViewer: PropTypes.bool.isRequired,

  actions: PropTypes.shape({
    clearSelection: PropTypes.func.isRequired,
    onAddPageToSelection: PropTypes.func.isRequired,
    onRemovePageFromSelection: PropTypes.func.isRequired,
    onSelectGalleryItem: PropTypes.func.isRequired,
    onStartDraggingPages: PropTypes.func.isRequired,
    renameGalleryItemRequest: PropTypes.func.isRequired,
    selectGalleryItem: PropTypes.func.isRequired,
    setDeleteGalleryItem: PropTypes.func.isRequired,
    setGalleryItemThumbnailIsLoaded: PropTypes.func.isRequired,
  }).isRequired,
  customVideoActions: PropTypes.shape({
    addTimelineItem: PropTypes.func.isRequired,
  }).isRequired,
  spatialModelActions: PropTypes.shape({
    addImageToModel: PropTypes.func.isRequired,
  }).isRequired,
  threedeeModelActions: PropTypes.shape({
    addImageTo3dModel: PropTypes.func.isRequired,
  }).isRequired,
  bentleyModelActions: PropTypes.shape({
    addImageToBentleyModel: PropTypes.func.isRequired,
  }).isRequired,
  bentleyAnalyticsReportActions: PropTypes.shape({
    addModelToBentleyAnalyticsReport: PropTypes.func.isRequired,
  }).isRequired,
  notificationActions: PropTypes.shape({
    onAddErrorNotification: PropTypes.func.isRequired,
  }).isRequired,
  sessionSharingActions: PropTypes.shape({
    addPageForSharing: PropTypes.func.isRequired,
  }).isRequired,
  classificationAnnotationsActions: PropTypes.shape({
    addPageToClassificationAnnotationsPages: PropTypes.func.isRequired,
  }).isRequired,
  sessionReviewingActions: PropTypes.shape({
    addPageForReviewing: PropTypes.func.isRequired,
  }).isRequired,
  splatModelActions: PropTypes.shape({
    addImageToSplatModel: PropTypes.func.isRequired,
  }).isRequired,
}

const mapStateToProps = (state, props) => {
  const {
    gallery,
    customVideo,
    spatialModel,
    threedeeModel,
    bentleyModel,
    bentleyAnalyticsReport,
    navbar,
    classificationAnnotationsPagesTimeline,
    splatModel,
  } = state

  return {
    item: getGalleryItem(state, props),
    selectedGalleryItemId: gallery.galleryState.selectedGalleryItemId,
    isCustomVideoOpen: customVideo.isTimelineOpen && navbar.bottom?.name === TabPanel.CustomVideo,
    isSpatialModelOpen: spatialModel.isTimelineOpen && navbar.bottom?.name === TabPanel.SpatialView,
    is3dModelOpen: threedeeModel.isTimelineOpen && navbar.bottom?.name === TabPanel.ThreeDModel,
    isBentleyModelOpen: bentleyModel.isTimelineOpen && navbar.bottom?.name === TabPanel.BentleyModel,
    isBentleyAnalyticsReportOpen:
      bentleyAnalyticsReport.isTimelineOpen && navbar.bottom?.name === TabPanel.BentleyAnalyticsReport,
    isSessionSharingPagesListOpen:
      state.shareSessionPagesList.isTimelineOpen && state.navbar.bottom?.name === TabPanel.ShareSession,
    isClassificationAnnotationsOpen:
      classificationAnnotationsPagesTimeline.isTimelineOpen &&
      navbar.bottom?.name === TabPanel.ClassificationAnnotations,
    isSplatModelOpen: splatModel.isTimelineOpen && navbar.bottom?.name === TabPanel.SplatModel,
    presenterId: contentStateSelectors.getPresenterId(state),
    currentUserId: accountSelectors.getCurrentUserId(state),
    isCallStarted: presentationSelectors.getIsCallStarted(state),
    ownerId: contentStateSelectors.getOwnerId(state),
    isGalleryExpanded: getIsTabExpanded(state, TabPanel.Gallery),
    isGalleryExpansionEnabled: getIsGalleryExpansionEnabled(state),
    isSessionReviewingPagesListOpen:
      state.reviewSessionPagesList.isTimelineOpen && state.navbar.bottom?.name === TabPanel.ReviewSession,
    isViewer: getIsCurrentUserViewer(state),
    canAddPointCloudPageToBentleyAnalyticsReport: bentleyAnalyticsReport.modelsList.length < 1,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(rawActions, dispatch),
    customVideoActions: bindActionCreators(customVideoActions, dispatch),
    spatialModelActions: bindActionCreators(spatialModelActions, dispatch),
    threedeeModelActions: bindActionCreators(threedeeModelActions, dispatch),
    bentleyModelActions: bindActionCreators(bentleyModelActions, dispatch),
    bentleyAnalyticsReportActions: bindActionCreators(bentleyAnalyticsReportActions, dispatch),
    sessionSharingActions: bindActionCreators(sessionSharingActions, dispatch),
    classificationAnnotationsActions: bindActionCreators(classificationAnnotationsActions, dispatch),
    notificationActions: bindActionCreators(notificationActions, dispatch),
    sessionReviewingActions: bindActionCreators(sessionReviewingActions, dispatch),
    splatModelActions: bindActionCreators(splatActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GalleryItemContainer)
